module.exports = __webpack_public_path__ + "img/titan.b8f62b9e.png";